import DataSetResponseNewContainer from './data_set_response_new_container';

const DataSetResponseNew = DataSetResponseNewContainer;

export default DataSetResponseNew;
